module.exports = __webpack_public_path__ + "media/icons/tick-circle-bd0afda5.svg";